{
  "navigation": {
    "dashboard": "Home"
  },
  "user": {
    "notifications": "Notifications"
  },
  "nav": {
    "mainNavigation": "Main navigation",
    "toggleSidebar": "Show/hide the side menu",
    "toggleSidebarHint": "Show or hide the menu",
    "home": "Home",
    "exchange": "Currency exchange system",
    "exchangeVip": "Currency exchange system (VIP)",
    "balance": "Box balance",
    "changeBranch": "Change Branch",
    "systems": "Systems",
    "cashEntries": "Cash receipts and payments"
  },
  "brand": "Al-Musafer"
}
